import { MainFooter } from '@marketplace-web/footer/footer-feature'

type Props = {
  isDigitalLawEnabled: boolean
  isBusinessInfoLinksEnabled: boolean
  onlineComplaintUrl?: string
}

const Footer = ({ isDigitalLawEnabled, isBusinessInfoLinksEnabled, onlineComplaintUrl }: Props) => (
  <div className="u-ui-margin-top-auto">
    <MainFooter
      isBusinessInfoLinksEnabled={isBusinessInfoLinksEnabled}
      isDigitalLawEnabled={isDigitalLawEnabled}
      onlineComplaintUrl={onlineComplaintUrl}
    />
  </div>
)

export default Footer
